
<div class="header-toolbar">
  <h1 *ngIf="mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'preview'">
    {{ title }}
    <span>Aperçu</span>
  </h1>
  <h1 *ngIf="mode === 'view'">
    {{ title }}
    <span>{{ entity?.name }}</span>
  </h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="movement">

  <!-- Toolbar -->
  <div *ngIf="mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!movement.valid || !entity.valid">
      <t-icon name="arrow_forward"></t-icon>
      <span class="text">Aperçu</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel($event)">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>

  <div *ngIf="mode === 'preview'" class="main btn-toolbar">

    <a class="btn" (click)="cancel($event)">
      <t-icon name="arrow_back"></t-icon>
      <span class="text">Retour</span>
    </a>

    &nbsp;

    <button *ngIf="subMode === 'default'"
      class="btn btn-primary" type="submit"
      [disabled]="!movement.valid || !entity.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Soumettre pour validation</span>
    </button>

    <button *ngIf="subMode === 'draft' && canCreateMovement"
      class="btn btn-primary"
      type="submit"
      [disabled]="!movement.valid || !entity.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Valider</span>
    </button>

  </div>
  
  <div *ngIf="mode === 'view'" class="main btn-toolbar">

    <a *ngIf="movement === lastMovement || subMode === 'draft'" class="btn btn-danger" (click)="deleteMovement($event)">
      <t-icon name="delete"></t-icon>
      <span class="text">Supprimer</span>
    </a>

    &nbsp;
        
    <a class="btn" routerLink="{{ cancelLink }}">
      <t-icon name="arrow_back"></t-icon>
      <span class="text">Retour</span>
    </a>

    &nbsp;

    <button *ngIf="subMode === 'draft'" class="btn" type="submit" [disabled]="!movement.valid || !entity.valid">
      <t-icon name="arrow_forward"></t-icon>
      <span class="text">Aperçu</span>
    </button>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="movement && mode !== 'preview'">

    <div class="column">

      <div *ngIf="mode === 'new'" class="panel">
        <h2>Mouvement</h2>

        <div class="form-group">
          <label for="createdAt">Date d'écriture</label>
          <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" type="text" placeholder="JJ/MM/AAAA" [formControl]="writingDate" [owlDateTimeFilter]="filterWritingDate()"/>
          <owl-date-time pickerType="calendar" firstDayOfWeek="1" pickerMode="dialog" #dt1></owl-date-time>
        </div>

        <div class="form-group">
          <label for="description">Description</label>
          <input id="description" type="text" placeholder="" [formControl]="description" maxlength="200"/>
          <span class="info info-error" [hidden]="description.valid || description.pristine || !description.errors.required">Ce champ est requis</span>
        </div>

      </div>

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Mouvement</h2>

        <div class="form-group">
          <label for="createdAt">Date d'écriture</label>
          <span id="createdAt" class="value">{{ movement.writingDate | movementwritingdate }}</span>
        </div>

        <div class="form-group">
          <label for="description">Description</label>
          <span id="description" class="value">{{ movement.description }}</span>
        </div>

      </div>

      <sl-entity-shareholders *ngIf="mode === 'new'" [entity]="entity" [canNavigate]="false"></sl-entity-shareholders>
      
      <div *ngIf="mode === 'view'" class="panel">
        <h2>Autres</h2>

        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ movement.id }}</span>
        </div>

        <div class="form-group">
          <label for="createdAt">Date d'ajout</label>
          <span id="createdAt" class="value">{{ movement.createdAt | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="createdBy">Ajouté par</label>
          <span id="createdBy" class="value">{{ movement.createdBy.fullname }}</span>
        </div>

        <div class="form-group" *ngIf="subMode === 'deleted'">
          <label for="deletedAt">Date de suppression</label>
          <span id="deletedAt" class="value">{{ movement.deletedAt | tzdate }}</span>
        </div>

        <div class="form-group" *ngIf="subMode === 'deleted'">
          <label for="deletedBy">Supprimé par</label>
          <span id="deletedBy" class="value">{{ movement.deletedBy.fullname }}</span>
        </div>
      </div>
      
    </div>

    <div class="column">

      <!-- Lines Edit -->
      <div *ngIf="mode === 'new'" class="panel">
        <h2>Lignes ({{ lines.length }})</h2>

        <div class="btn-toolbar">

          <ng-container *ngIf="lines && lines.length > 0">
            <a class="btn btn-small btn-gray" title="Ajouter une ligne" (click)="addOneLine()">
              <t-icon name="add"></t-icon>
              <span class="text">Ajouter une ligne</span>
            </a>
            &nbsp;
            <a class="btn btn-small btn-gray" title="Ajouter un démembrement" (click)="addDismembermentLines($event)">
              <t-icon name="call_split"></t-icon>
              <span class="text">Ajouter un démembrement</span>
            </a>
        </ng-container>

        </div>

        <div *ngIf="!lines || lines.length === 0" class="empty-table">

          <p>Veuillez ajouter une ligne ou un démembrement</p>
        
          <a class="btn btn-small btn-gray" title="Ajouter une ligne" (click)="addOneLine()">
            <t-icon name="add"></t-icon>
            <span class="text">Ajouter une ligne</span>
          </a>
          &nbsp;
          <a class="btn btn-small btn-gray" title="Ajouter un démembrement" (click)="addDismembermentLines($event)">
            <t-icon name="call_split"></t-icon>
            <span class="text">Ajouter un démembrement</span>
          </a>
        
        </div>

        
        <div *ngFor="let line of lines; index as i" class="movement-line">
          
          <h3>
            Ligne #{{ i+1 }}
            <span *ngIf="line.model.isHidden" class="is-hidden">[Masquée]</span>
          </h3>

          <div class="actions">
            <a class="action-btn" (click)="removeMovementLine(line)" title="Supprimer">
              <t-icon name="delete"></t-icon>
            </a>
          </div>


          <div class="form-group">
            <label>Entité</label>

            <t-entity-lookup [control]="line.entity" [hideId]="entity.id"></t-entity-lookup>

            <span class="info info-error" [hidden]="line.model.entity">Veuillez sélectionner ou ajouter une entité</span>

            <div class="text-right" style="padding-top: 8px;">
              
              <a class="btn btn-small btn-gray" title="Ajouter une nouvelle entité" (click)="addEntity($event, line)">
                <t-icon name="add"></t-icon>
                <span class="text">Ajouter</span>
              </a>
            </div>

          </div>

          <!-- Retracted -->
          <ng-container *ngIf="!line.isExpanded">

            <div class="form-group">

              <div class="inputs-row" [formGroup]="line.group">
                <select title="Opération" formControlName="operation">
                  <option *ngFor="let opt of movementLineOperationOptions" [ngValue]="opt.value">{{opt.text}}</option>
                </select>

                <input type="text" placeholder="Nombre d'actions" [formControl]="line.amount" maxlength="200"/>

                <select title="Type de propriété" formControlName="ownership">
                  <option *ngFor="let opt of movementLineOwnershipOptions" [ngValue]="opt.value">{{opt.value}}</option>
                </select>

                <select title="Type d'actions" formControlName="shareType">
                  <option *ngFor="let opt of movementLineShareTypeOptions" [ngValue]="opt.value">{{opt.textShort}}</option>
                </select>

                <select title="Nature du mouvement" formControlName="nature">
                  <option *ngFor="let opt of movementLineNatureOptions(line.model)" [ngValue]="opt.value">{{opt.text}}</option>
                </select>

              </div>

              <span class="info info-error" [hidden]="line.amount.valid || line.amount.pristine || !line.amount.errors.required">Ce champ est requis</span>
              <span class="info info-error" [hidden]="line.amount.valid || line.amount.pristine || !line.amount.errors.positive">Veuillez saisir un nombre positif</span>

            </div>

          </ng-container>

          <div class="form-group form-group-narrow">
            <t-checkbox label="Masquer cette ligne" [(checked)]="line.model.isHidden"></t-checkbox>
          </div>

        </div>
        
      </div>

      <!-- Lines view -->
      <div *ngIf="mode === 'view' && subMode !== 'draft'" class="panel">
        <h2>Lignes ({{ movement.lines.length }})</h2>

        <table>
          <thead>
            <tr>
              <th>Entité</th>
              <th style="width: 100px;">Opération</th>
              <th style="width: 180px;">Nature du mouvement</th>
              <th>Nombre d'actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of movement.lines">
              <td name="Entité">{{ line.entity.name }}</td>
              <td style="width: 100px;" name="Opération">{{ line.operation | slmovementlineoperation }}</td>
              <td style="width: 180px;" name="Nature du mouvement'">{{ line.nature | slmovementlinenature }}</td>
              <td name="Nombre d'actions" title="{{ line.ownership | slmovementlineownership }} {{ line.shareType | slmovementlinesharetype:short }}">
                {{ line.amount }}
                {{ line.ownership }}
                {{ line.shareType | slmovementlinesharetype:'short' }}
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- Lines view -->
      <div *ngIf="mode === 'view' && subMode === 'draft'" class="panel">
        <h2>Lignes ({{ movement.lines.length }})</h2>

        <table>
          <thead>
            <tr>
              <th style="width: 50px;"></th>
              <th>Entité</th>
              <th>Version</th>
              <th style="width: 100px;">Opération</th>
              <th style="width: 180px;">Nature du mouvement</th>
              <th>Nombre d'actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of movement.lines; index as idx">
              <td class="icons" style="width: 50px;">
                <t-icon *ngIf="linesIssues[idx].type === 'WARNING'" name="warning" [attr.title]="linesIssues[idx].message"></t-icon>
                <t-icon *ngIf="linesIssues[idx].type === 'ERROR'" class="error" name="error" [attr.title]="linesIssues[idx].message"></t-icon>
                <t-icon *ngIf="linesIssues[idx].type === 'GOOD'" class="success" name="check_circle_outline" [attr.title]="linesIssues[idx].message"></t-icon>
              </td>
              <td name="Entité">{{ line.entity.name }}</td>
              <td name="Version">{{ line.entity.version }}</td>
              <td style="width: 100px;" name="Opération">{{ line.operation | slmovementlineoperation }}</td>
              <td style="width: 180px;" name="Nature du mouvement'">{{ line.nature | slmovementlinenature }}</td>
              <td name="Nombre d'actions" title="{{ line.ownership | slmovementlineownership }} {{ line.shareType | slmovementlinesharetype:short }}">
                {{ line.amount }}
                {{ line.ownership }}
                {{ line.shareType | slmovementlinesharetype:'short' }}
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- Attachment edit -->
      <div *ngIf="mode === 'new'" class="panel">
        <h2>Pièces jointes ({{ movement.attachments.length }})</h2>
        
        <table class="attachments">
          <tbody>
            <tr *ngFor="let attachment of attachments">
              
              <!--Icons-->
              <td class="icons" *ngIf="attachment.status === 'START'">
                <t-icon name="query_builder"></t-icon>
              </td>
              
              <td class="icons small-percent" *ngIf="attachment.status === 'UPLOADING'">
                <t-percent [total]="100" [value]="attachment.progress" [showValue]="false" [size]="20" [radius]="8"></t-percent>
              </td>
              
              <td class="icons" *ngIf="attachment.status === 'DIGEST'">
                <t-icon name="fingerprint" class="digest"></t-icon>
              </td>
              
              <td class="icons" *ngIf="attachment.status === 'DONE'">
                <t-icon name="check_circle_outline" class="success"></t-icon>
              </td>
              
              <td class="icons" *ngIf="attachment.status === 'ERROR'">
                <t-icon name="warning" class="error"></t-icon>
              </td>

  
              <!--Details-->
              <td>
                {{ attachment.model.filename }}
  
                <div class="item-details" *ngIf="attachment.status === 'START'">
                  <div>
                    <label>Statut</label>
                    <span>Préparation...</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="attachment.status === 'UPLOADING'">
                  <div>
                    <label>Statut</label>
                    <span>Téléchargement {{ attachment.progress }}%</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="attachment.status === 'DIGEST'">
                  <div>
                    <label>Statut</label>
                    <span>Calcul de la signature numérique...</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="attachment.status === 'DONE'">
                  <div>
                    <label>Signature</label>
                    <span class="digest" title="{{ attachment.model.digest }}">
                      {{ attachment.model.digest}}
                    </span>
                  </div>
                  <div>
                    <label>Taille</label>
                    <span>{{ attachment.model.filesize | filesize }}</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="attachment.status === 'ERROR'">
                  <div>
                    <label>Statut</label>
                    <span>Une erreur s'est produite, veuillez supprimer ce fichier et réessayer</span>
                  </div>
                </div>

              </td>
  
              <td style="width: 50px;" class="actions">
                <a class="action-btn" (click)="removeAttachment(attachment)">
                  <t-icon name="delete"></t-icon>
                </a>
              </td>

            </tr>
          </tbody>
        </table>

        <div class="form-group">
          <label class="file-select"
            ng2FileDrop
            (fileOver)="isFileOver = $event"
            [uploader]="uploader"
            [ngClass]="{ 'over': isFileOver }"
            for="file"
            >
            <t-icon name="attachment"></t-icon>
            <span class="text">Joindre un nouveau fichier</span>
          </label>
          <input id="file" type="file" style="display: none" ng2FileSelect multiple (onFileSelected)="onAttachmentsAdded($event)" [uploader]="uploader" />
        </div>

      </div>

      <!-- Attachment view -->
      <div *ngIf="mode === 'view'" class="panel">
        <h2>Pièces jointes ({{ movement.attachments.length }})</h2>
        

        <table class="attachments">
          <tbody>
            <tr *ngFor="let attachment of movement.attachments">
              
              <!--Details-->
              <td>
                {{ attachment.filename }}
  
                <div class="item-details">
                  <div>
                    <label>Signature</label>
                    <span class="digest" title="{{ attachment.digest }}">
                      {{ attachment.digest}}
                    </span>
                  </div>
                  <div>
                    <label>Taille</label>
                    <span>{{ attachment.filesize | filesize }}</span>
                  </div>
                </div>

              </td>
  
              <td style="width: 50px;" class="actions">
                <a *ngIf="this.subMode === 'draft'" class="action-btn" href="/files/shares-ledger/draft-attachment/{{ attachment.id }}">
                  <t-icon name="file_download"></t-icon>
                </a>
                <a *ngIf="this.subMode !== 'draft'" class="action-btn" href="/files/shares-ledger/attachment/{{ entity.id }}/{{ movement.id }}/{{ attachment.id }}">
                  <t-icon name="file_download"></t-icon>
                </a>
              </td>

            </tr>
          </tbody>
        </table>

        <div class="empty-table compact" *ngIf="movement.attachments.length === 0">
          <p>Aucune pièce jointe dans ce mouvement</p>
        </div>

      </div>

    </div>

  </div>

  <div *ngIf="movement && mode === 'preview'">
    <div class="form-group">
      <t-checkbox label="Afficher les lignes masquées" [(checked)]="previewShowHidden"></t-checkbox>
    </div>
    
    <sl-entity-movements-ledger [entity]="previewEntity" [showHidden]="previewShowHidden"></sl-entity-movements-ledger>
  </div>

</form>